export default __webpack_public_path__ + "static/media/DNo.25-7.3cca8ba0.jpg";